var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',_vm._g(_vm._b({staticStyle:{"width":"100%"},attrs:{"clearable":""}},'el-select',_vm.$attrs,false),_vm.$listeners),_vm._l((_vm.platforms),function(item,key){return _c('el-option',{key:key,attrs:{"label":item.name,"value":item.code}},[_vm._v(" "+_vm._s(item.name)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }